import requests from "./httpService";

const CancellationPolicyServices = {
  getAllCancellationPolicy: async (type) => {
    return requests.get(`/cancellationPolicy/${type}`);
  },

 

  updateCancellationPolicy: async (type, body) => {
    return requests.put(`/cancellationPolicy/update/${type}`,body);
  }

 
};

export default CancellationPolicyServices;
